import './index.css';

// import registerServiceWorker from './registerServiceWorker';
import { defaultDataIdFromObject, InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import { withClientState } from 'apollo-link-state';
import * as cookies from 'browser-cookies';
import * as firebase from 'firebase';
import moment from 'moment';
import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import * as ReactDOM from 'react-dom';

import App from './App';

const httpLink = createHttpLink({
  credentials: "include",
  uri:
    process.env.NODE_ENV === "production"
      ? "https://upcoming-service.turnlab.solutions/graphql"
      : "http://localhost:8080/graphql",
});

const inMemorycache = new InMemoryCache({
  dataIdFromObject: (object) => {
    switch (object.__typename) {
      case "MovieList":
        return `${object.__typename}:${object.id}:${(object as any).filter}`;
      default:
        return defaultDataIdFromObject(object);
    }
  },
});

const stateLink = withClientState({
  cache: inMemorycache,
  defaults: {
    sidebar: {
      __typename: "Sidebar",
      display: false,
    },
    user: {
      __typename: "User",
      id: null,
      photoURL: null,
      token: null,
      username: null,
    },
  },
  resolvers: {
    Mutation: {
      toggleSidebar: (_, { display }, { cache }) => {
        const data = {
          sidebar: {
            __typename: "Sidebar",
            display,
          },
        };
        cache.writeData({ data });
        return null;
      },
      updateUser: (_, { user }, { cache }) => {
        const data = {
          user: {
            __typename: "User",
            ...user,
          },
        };
        cache.writeData({ data });
        return null;
      },
    },
  },
});

const client = new ApolloClient({
  cache: inMemorycache,
  link: ApolloLink.from([stateLink, httpLink]),
});

(window as any).app = firebase.initializeApp({
  apiKey: "AIzaSyCT9yxzI4q-mErsfg83Sf1xQVUT5ZdypRc",
  authDomain: "upcoming-d0522.firebaseapp.com",
  databaseURL: "https://upcoming-d0522.firebaseio.com",
  messagingSenderId: "1005552566736",
  projectId: "upcoming-d0522",
  storageBucket: "upcoming-d0522.appspot.com",
});

cookies.set("upcoming-utc-offset", `${moment().utcOffset()}`, {
  domain: ".upcomi.ng",
  expires: 365,
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById("root") as HTMLElement
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx